// The sign-in page for the protected NorthStar pages (/login).
//
// Accounts are Netlify Identity. The gate (netlify/edge-functions/editor-auth.js)
// sends anybody without a session here as /login?next=<the page they wanted>,
// and checks the session this page leaves behind: the nf_jwt and nf_refresh
// cookies that @netlify/identity writes. So everything here ends one of two
// ways: those cookies are set and the visitor goes back to `next`, or they are
// told what to do instead.
//
// Netlify's own emails link to the front page with a token in the hash
// (#invite_token=…, #recovery_token=…, #confirmation_token=…); src/index.html
// forwards those here, and handleAuthCallback() reads them.
// src/api.ts
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $44cd0bd3a1192d9a$export$a143d493d941bafc;
var $44cd0bd3a1192d9a$export$e4cf37d7f6fb9e0a;
var $44cd0bd3a1192d9a$export$f99ded8fe4b79145;
var $44cd0bd3a1192d9a$export$599f31c3813fae4d;
'use strict';
var $1fa3cb0d676f4b02$export$a48f0734ac7c2329;
var $1fa3cb0d676f4b02$export$d622b2ad8d90c771;
var $1fa3cb0d676f4b02$export$6100ba28696e12de;
'use strict';
$1fa3cb0d676f4b02$export$a48f0734ac7c2329 = $1fa3cb0d676f4b02$var$byteLength;
$1fa3cb0d676f4b02$export$d622b2ad8d90c771 = $1fa3cb0d676f4b02$var$toByteArray;
$1fa3cb0d676f4b02$export$6100ba28696e12de = $1fa3cb0d676f4b02$var$fromByteArray;
var $1fa3cb0d676f4b02$var$lookup = [];
var $1fa3cb0d676f4b02$var$revLookup = [];
var $1fa3cb0d676f4b02$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $1fa3cb0d676f4b02$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $1fa3cb0d676f4b02$var$i = 0, $1fa3cb0d676f4b02$var$len = $1fa3cb0d676f4b02$var$code.length; $1fa3cb0d676f4b02$var$i < $1fa3cb0d676f4b02$var$len; ++$1fa3cb0d676f4b02$var$i){
    $1fa3cb0d676f4b02$var$lookup[$1fa3cb0d676f4b02$var$i] = $1fa3cb0d676f4b02$var$code[$1fa3cb0d676f4b02$var$i];
    $1fa3cb0d676f4b02$var$revLookup[$1fa3cb0d676f4b02$var$code.charCodeAt($1fa3cb0d676f4b02$var$i)] = $1fa3cb0d676f4b02$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$1fa3cb0d676f4b02$var$revLookup['-'.charCodeAt(0)] = 62;
$1fa3cb0d676f4b02$var$revLookup['_'.charCodeAt(0)] = 63;
function $1fa3cb0d676f4b02$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $1fa3cb0d676f4b02$var$byteLength(b64) {
    var lens = $1fa3cb0d676f4b02$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $1fa3cb0d676f4b02$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $1fa3cb0d676f4b02$var$toByteArray(b64) {
    var tmp;
    var lens = $1fa3cb0d676f4b02$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $1fa3cb0d676f4b02$var$Arr($1fa3cb0d676f4b02$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $1fa3cb0d676f4b02$var$revLookup[b64.charCodeAt(i)] << 18 | $1fa3cb0d676f4b02$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $1fa3cb0d676f4b02$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $1fa3cb0d676f4b02$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $1fa3cb0d676f4b02$var$revLookup[b64.charCodeAt(i)] << 2 | $1fa3cb0d676f4b02$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $1fa3cb0d676f4b02$var$revLookup[b64.charCodeAt(i)] << 10 | $1fa3cb0d676f4b02$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $1fa3cb0d676f4b02$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $1fa3cb0d676f4b02$var$tripletToBase64(num) {
    return $1fa3cb0d676f4b02$var$lookup[num >> 18 & 0x3F] + $1fa3cb0d676f4b02$var$lookup[num >> 12 & 0x3F] + $1fa3cb0d676f4b02$var$lookup[num >> 6 & 0x3F] + $1fa3cb0d676f4b02$var$lookup[num & 0x3F];
}
function $1fa3cb0d676f4b02$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($1fa3cb0d676f4b02$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $1fa3cb0d676f4b02$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($1fa3cb0d676f4b02$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($1fa3cb0d676f4b02$var$lookup[tmp >> 2] + $1fa3cb0d676f4b02$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($1fa3cb0d676f4b02$var$lookup[tmp >> 10] + $1fa3cb0d676f4b02$var$lookup[tmp >> 4 & 0x3F] + $1fa3cb0d676f4b02$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $58c550a140bdb182$export$aafa59e2e03f2942;
var $58c550a140bdb182$export$68d8715fc104d294;
$58c550a140bdb182$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$58c550a140bdb182$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $44cd0bd3a1192d9a$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$44cd0bd3a1192d9a$export$a143d493d941bafc = $44cd0bd3a1192d9a$var$Buffer;
$44cd0bd3a1192d9a$export$e4cf37d7f6fb9e0a = $44cd0bd3a1192d9a$var$SlowBuffer;
$44cd0bd3a1192d9a$export$f99ded8fe4b79145 = 50;
const $44cd0bd3a1192d9a$var$K_MAX_LENGTH = 0x7fffffff;
$44cd0bd3a1192d9a$export$599f31c3813fae4d = $44cd0bd3a1192d9a$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $44cd0bd3a1192d9a$var$Buffer.TYPED_ARRAY_SUPPORT = $44cd0bd3a1192d9a$var$typedArraySupport();
if (!$44cd0bd3a1192d9a$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $44cd0bd3a1192d9a$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($44cd0bd3a1192d9a$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$44cd0bd3a1192d9a$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($44cd0bd3a1192d9a$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$44cd0bd3a1192d9a$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $44cd0bd3a1192d9a$var$createBuffer(length) {
    if (length > $44cd0bd3a1192d9a$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $44cd0bd3a1192d9a$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $44cd0bd3a1192d9a$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $44cd0bd3a1192d9a$var$allocUnsafe(arg);
    }
    return $44cd0bd3a1192d9a$var$from(arg, encodingOrOffset, length);
}
$44cd0bd3a1192d9a$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $44cd0bd3a1192d9a$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $44cd0bd3a1192d9a$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $44cd0bd3a1192d9a$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($44cd0bd3a1192d9a$var$isInstance(value, ArrayBuffer) || value && $44cd0bd3a1192d9a$var$isInstance(value.buffer, ArrayBuffer)) return $44cd0bd3a1192d9a$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($44cd0bd3a1192d9a$var$isInstance(value, SharedArrayBuffer) || value && $44cd0bd3a1192d9a$var$isInstance(value.buffer, SharedArrayBuffer))) return $44cd0bd3a1192d9a$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $44cd0bd3a1192d9a$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $44cd0bd3a1192d9a$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $44cd0bd3a1192d9a$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $44cd0bd3a1192d9a$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $44cd0bd3a1192d9a$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($44cd0bd3a1192d9a$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($44cd0bd3a1192d9a$var$Buffer, Uint8Array);
function $44cd0bd3a1192d9a$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $44cd0bd3a1192d9a$var$alloc(size, fill, encoding) {
    $44cd0bd3a1192d9a$var$assertSize(size);
    if (size <= 0) return $44cd0bd3a1192d9a$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $44cd0bd3a1192d9a$var$createBuffer(size).fill(fill, encoding) : $44cd0bd3a1192d9a$var$createBuffer(size).fill(fill);
    return $44cd0bd3a1192d9a$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $44cd0bd3a1192d9a$var$Buffer.alloc = function(size, fill, encoding) {
    return $44cd0bd3a1192d9a$var$alloc(size, fill, encoding);
};
function $44cd0bd3a1192d9a$var$allocUnsafe(size) {
    $44cd0bd3a1192d9a$var$assertSize(size);
    return $44cd0bd3a1192d9a$var$createBuffer(size < 0 ? 0 : $44cd0bd3a1192d9a$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $44cd0bd3a1192d9a$var$Buffer.allocUnsafe = function(size) {
    return $44cd0bd3a1192d9a$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $44cd0bd3a1192d9a$var$Buffer.allocUnsafeSlow = function(size) {
    return $44cd0bd3a1192d9a$var$allocUnsafe(size);
};
function $44cd0bd3a1192d9a$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$44cd0bd3a1192d9a$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $44cd0bd3a1192d9a$var$byteLength(string, encoding) | 0;
    let buf = $44cd0bd3a1192d9a$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $44cd0bd3a1192d9a$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $44cd0bd3a1192d9a$var$checked(array.length) | 0;
    const buf = $44cd0bd3a1192d9a$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $44cd0bd3a1192d9a$var$fromArrayView(arrayView) {
    if ($44cd0bd3a1192d9a$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $44cd0bd3a1192d9a$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $44cd0bd3a1192d9a$var$fromArrayLike(arrayView);
}
function $44cd0bd3a1192d9a$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $44cd0bd3a1192d9a$var$Buffer.prototype);
    return buf;
}
function $44cd0bd3a1192d9a$var$fromObject(obj) {
    if ($44cd0bd3a1192d9a$var$Buffer.isBuffer(obj)) {
        const len = $44cd0bd3a1192d9a$var$checked(obj.length) | 0;
        const buf = $44cd0bd3a1192d9a$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $44cd0bd3a1192d9a$var$numberIsNaN(obj.length)) return $44cd0bd3a1192d9a$var$createBuffer(0);
        return $44cd0bd3a1192d9a$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $44cd0bd3a1192d9a$var$fromArrayLike(obj.data);
}
function $44cd0bd3a1192d9a$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $44cd0bd3a1192d9a$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $44cd0bd3a1192d9a$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $44cd0bd3a1192d9a$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $44cd0bd3a1192d9a$var$Buffer.alloc(+length);
}
$44cd0bd3a1192d9a$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $44cd0bd3a1192d9a$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$44cd0bd3a1192d9a$var$Buffer.compare = function compare(a, b) {
    if ($44cd0bd3a1192d9a$var$isInstance(a, Uint8Array)) a = $44cd0bd3a1192d9a$var$Buffer.from(a, a.offset, a.byteLength);
    if ($44cd0bd3a1192d9a$var$isInstance(b, Uint8Array)) b = $44cd0bd3a1192d9a$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$44cd0bd3a1192d9a$var$Buffer.isBuffer(a) || !$44cd0bd3a1192d9a$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$44cd0bd3a1192d9a$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$44cd0bd3a1192d9a$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $44cd0bd3a1192d9a$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $44cd0bd3a1192d9a$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($44cd0bd3a1192d9a$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$44cd0bd3a1192d9a$var$Buffer.isBuffer(buf)) buf = $44cd0bd3a1192d9a$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$44cd0bd3a1192d9a$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $44cd0bd3a1192d9a$var$byteLength(string, encoding) {
    if ($44cd0bd3a1192d9a$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $44cd0bd3a1192d9a$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $44cd0bd3a1192d9a$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $44cd0bd3a1192d9a$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $44cd0bd3a1192d9a$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$44cd0bd3a1192d9a$var$Buffer.byteLength = $44cd0bd3a1192d9a$var$byteLength;
function $44cd0bd3a1192d9a$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $44cd0bd3a1192d9a$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $44cd0bd3a1192d9a$var$utf8Slice(this, start, end);
        case 'ascii':
            return $44cd0bd3a1192d9a$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $44cd0bd3a1192d9a$var$latin1Slice(this, start, end);
        case 'base64':
            return $44cd0bd3a1192d9a$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $44cd0bd3a1192d9a$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$44cd0bd3a1192d9a$var$Buffer.prototype._isBuffer = true;
function $44cd0bd3a1192d9a$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$44cd0bd3a1192d9a$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$44cd0bd3a1192d9a$var$swap(this, i, i + 1);
    return this;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $44cd0bd3a1192d9a$var$swap(this, i, i + 3);
        $44cd0bd3a1192d9a$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $44cd0bd3a1192d9a$var$swap(this, i, i + 7);
        $44cd0bd3a1192d9a$var$swap(this, i + 1, i + 6);
        $44cd0bd3a1192d9a$var$swap(this, i + 2, i + 5);
        $44cd0bd3a1192d9a$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $44cd0bd3a1192d9a$var$utf8Slice(this, 0, length);
    return $44cd0bd3a1192d9a$var$slowToString.apply(this, arguments);
};
$44cd0bd3a1192d9a$var$Buffer.prototype.toLocaleString = $44cd0bd3a1192d9a$var$Buffer.prototype.toString;
$44cd0bd3a1192d9a$var$Buffer.prototype.equals = function equals(b) {
    if (!$44cd0bd3a1192d9a$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $44cd0bd3a1192d9a$var$Buffer.compare(this, b) === 0;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $44cd0bd3a1192d9a$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($44cd0bd3a1192d9a$var$customInspectSymbol) $44cd0bd3a1192d9a$var$Buffer.prototype[$44cd0bd3a1192d9a$var$customInspectSymbol] = $44cd0bd3a1192d9a$var$Buffer.prototype.inspect;
$44cd0bd3a1192d9a$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($44cd0bd3a1192d9a$var$isInstance(target, Uint8Array)) target = $44cd0bd3a1192d9a$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$44cd0bd3a1192d9a$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $44cd0bd3a1192d9a$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($44cd0bd3a1192d9a$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $44cd0bd3a1192d9a$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($44cd0bd3a1192d9a$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $44cd0bd3a1192d9a$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $44cd0bd3a1192d9a$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $44cd0bd3a1192d9a$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$44cd0bd3a1192d9a$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $44cd0bd3a1192d9a$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$44cd0bd3a1192d9a$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $44cd0bd3a1192d9a$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $44cd0bd3a1192d9a$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($44cd0bd3a1192d9a$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $44cd0bd3a1192d9a$var$utf8Write(buf, string, offset, length) {
    return $44cd0bd3a1192d9a$var$blitBuffer($44cd0bd3a1192d9a$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $44cd0bd3a1192d9a$var$asciiWrite(buf, string, offset, length) {
    return $44cd0bd3a1192d9a$var$blitBuffer($44cd0bd3a1192d9a$var$asciiToBytes(string), buf, offset, length);
}
function $44cd0bd3a1192d9a$var$base64Write(buf, string, offset, length) {
    return $44cd0bd3a1192d9a$var$blitBuffer($44cd0bd3a1192d9a$var$base64ToBytes(string), buf, offset, length);
}
function $44cd0bd3a1192d9a$var$ucs2Write(buf, string, offset, length) {
    return $44cd0bd3a1192d9a$var$blitBuffer($44cd0bd3a1192d9a$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$44cd0bd3a1192d9a$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $44cd0bd3a1192d9a$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $44cd0bd3a1192d9a$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $44cd0bd3a1192d9a$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $44cd0bd3a1192d9a$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $44cd0bd3a1192d9a$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$44cd0bd3a1192d9a$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $44cd0bd3a1192d9a$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $1fa3cb0d676f4b02$export$6100ba28696e12de(buf);
    else return $1fa3cb0d676f4b02$export$6100ba28696e12de(buf.slice(start, end));
}
function $44cd0bd3a1192d9a$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $44cd0bd3a1192d9a$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $44cd0bd3a1192d9a$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $44cd0bd3a1192d9a$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $44cd0bd3a1192d9a$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $44cd0bd3a1192d9a$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $44cd0bd3a1192d9a$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $44cd0bd3a1192d9a$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $44cd0bd3a1192d9a$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $44cd0bd3a1192d9a$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $44cd0bd3a1192d9a$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$44cd0bd3a1192d9a$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $44cd0bd3a1192d9a$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $44cd0bd3a1192d9a$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$44cd0bd3a1192d9a$var$Buffer.prototype.readUintLE = $44cd0bd3a1192d9a$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readUintBE = $44cd0bd3a1192d9a$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readUint8 = $44cd0bd3a1192d9a$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readUint16LE = $44cd0bd3a1192d9a$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readUint16BE = $44cd0bd3a1192d9a$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readUint32LE = $44cd0bd3a1192d9a$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readUint32BE = $44cd0bd3a1192d9a$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readBigUInt64LE = $44cd0bd3a1192d9a$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $44cd0bd3a1192d9a$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $44cd0bd3a1192d9a$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$44cd0bd3a1192d9a$var$Buffer.prototype.readBigUInt64BE = $44cd0bd3a1192d9a$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $44cd0bd3a1192d9a$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $44cd0bd3a1192d9a$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$44cd0bd3a1192d9a$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readBigInt64LE = $44cd0bd3a1192d9a$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $44cd0bd3a1192d9a$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $44cd0bd3a1192d9a$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$44cd0bd3a1192d9a$var$Buffer.prototype.readBigInt64BE = $44cd0bd3a1192d9a$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $44cd0bd3a1192d9a$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $44cd0bd3a1192d9a$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$44cd0bd3a1192d9a$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 4, this.length);
    return $58c550a140bdb182$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 4, this.length);
    return $58c550a140bdb182$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 8, this.length);
    return $58c550a140bdb182$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 8, this.length);
    return $58c550a140bdb182$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $44cd0bd3a1192d9a$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$44cd0bd3a1192d9a$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$44cd0bd3a1192d9a$var$Buffer.prototype.writeUintLE = $44cd0bd3a1192d9a$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $44cd0bd3a1192d9a$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeUintBE = $44cd0bd3a1192d9a$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $44cd0bd3a1192d9a$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeUint8 = $44cd0bd3a1192d9a$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeUint16LE = $44cd0bd3a1192d9a$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeUint16BE = $44cd0bd3a1192d9a$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeUint32LE = $44cd0bd3a1192d9a$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeUint32BE = $44cd0bd3a1192d9a$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $44cd0bd3a1192d9a$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $44cd0bd3a1192d9a$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $44cd0bd3a1192d9a$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $44cd0bd3a1192d9a$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$44cd0bd3a1192d9a$var$Buffer.prototype.writeBigUInt64LE = $44cd0bd3a1192d9a$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $44cd0bd3a1192d9a$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$44cd0bd3a1192d9a$var$Buffer.prototype.writeBigUInt64BE = $44cd0bd3a1192d9a$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $44cd0bd3a1192d9a$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$44cd0bd3a1192d9a$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $44cd0bd3a1192d9a$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $44cd0bd3a1192d9a$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeBigInt64LE = $44cd0bd3a1192d9a$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $44cd0bd3a1192d9a$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$44cd0bd3a1192d9a$var$Buffer.prototype.writeBigInt64BE = $44cd0bd3a1192d9a$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $44cd0bd3a1192d9a$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $44cd0bd3a1192d9a$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $44cd0bd3a1192d9a$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $58c550a140bdb182$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$44cd0bd3a1192d9a$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $44cd0bd3a1192d9a$var$writeFloat(this, value, offset, true, noAssert);
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $44cd0bd3a1192d9a$var$writeFloat(this, value, offset, false, noAssert);
};
function $44cd0bd3a1192d9a$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $58c550a140bdb182$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$44cd0bd3a1192d9a$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $44cd0bd3a1192d9a$var$writeDouble(this, value, offset, true, noAssert);
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $44cd0bd3a1192d9a$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$44cd0bd3a1192d9a$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$44cd0bd3a1192d9a$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$44cd0bd3a1192d9a$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$44cd0bd3a1192d9a$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $44cd0bd3a1192d9a$var$Buffer.isBuffer(val) ? val : $44cd0bd3a1192d9a$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $44cd0bd3a1192d9a$var$errors = {};
function $44cd0bd3a1192d9a$var$E(sym, getMessage, Base) {
    $44cd0bd3a1192d9a$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$44cd0bd3a1192d9a$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$44cd0bd3a1192d9a$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$44cd0bd3a1192d9a$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $44cd0bd3a1192d9a$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $44cd0bd3a1192d9a$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $44cd0bd3a1192d9a$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $44cd0bd3a1192d9a$var$checkBounds(buf, offset, byteLength) {
    $44cd0bd3a1192d9a$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $44cd0bd3a1192d9a$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $44cd0bd3a1192d9a$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $44cd0bd3a1192d9a$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $44cd0bd3a1192d9a$var$checkBounds(buf, offset, byteLength);
}
function $44cd0bd3a1192d9a$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $44cd0bd3a1192d9a$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $44cd0bd3a1192d9a$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $44cd0bd3a1192d9a$var$validateNumber(value, type);
        throw new $44cd0bd3a1192d9a$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $44cd0bd3a1192d9a$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $44cd0bd3a1192d9a$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $44cd0bd3a1192d9a$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $44cd0bd3a1192d9a$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($44cd0bd3a1192d9a$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $44cd0bd3a1192d9a$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $44cd0bd3a1192d9a$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $44cd0bd3a1192d9a$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $44cd0bd3a1192d9a$var$base64ToBytes(str) {
    return $1fa3cb0d676f4b02$export$d622b2ad8d90c771($44cd0bd3a1192d9a$var$base64clean(str));
}
function $44cd0bd3a1192d9a$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $44cd0bd3a1192d9a$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $44cd0bd3a1192d9a$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $44cd0bd3a1192d9a$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $44cd0bd3a1192d9a$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $44cd0bd3a1192d9a$var$BufferBigIntNotDefined : fn;
}
function $44cd0bd3a1192d9a$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $cfaa407c6a1db17d$require$Buffer = $44cd0bd3a1192d9a$export$a143d493d941bafc;
var $cfaa407c6a1db17d$export$aa9d629c530f62a7 = class extends Error {
    constructor(response){
        super(response.statusText);
        this.name = "HTTPError";
        this.status = response.status;
    }
};
var $cfaa407c6a1db17d$export$938c4d895465b9d3 = class extends $cfaa407c6a1db17d$export$aa9d629c530f62a7 {
    constructor(response, data){
        super(response);
        this.name = "TextHTTPError";
        this.data = data;
    }
};
var $cfaa407c6a1db17d$export$21308bf12e4debfb = class extends $cfaa407c6a1db17d$export$aa9d629c530f62a7 {
    constructor(response, json){
        super(response);
        this.name = "JSONHTTPError";
        this.json = json;
    }
};
var $cfaa407c6a1db17d$var$API = class _API {
    constructor(apiURL, options){
        this.apiURL = apiURL || "";
        this._sameOrigin = /^\/(?!\/)/.test(this.apiURL);
        this.defaultHeaders = options?.defaultHeaders || {};
    }
    headers(headers = {}) {
        return {
            ...this.defaultHeaders,
            "Content-Type": "application/json",
            ...headers
        };
    }
    static async parseJsonResponse(response) {
        const json = await response.json();
        if (!response.ok) throw new $cfaa407c6a1db17d$export$21308bf12e4debfb(response, json);
        return json;
    }
    async request(path, options = {}) {
        const headers = this.headers(options.headers || {});
        if (!options.body) delete headers["Content-Type"];
        const fetchOptions = {
            ...options,
            headers: headers
        };
        if (this._sameOrigin) fetchOptions.credentials = options.credentials || "same-origin";
        const response = await fetch(this.apiURL + path, fetchOptions);
        const contentType = response.headers.get("Content-Type");
        if (contentType?.includes("json")) return _API.parseJsonResponse(response);
        const data = await response.text();
        if (!response.ok) throw new $cfaa407c6a1db17d$export$938c4d895465b9d3(response, data);
        return data;
    }
};
// src/admin.ts
var $cfaa407c6a1db17d$export$c67a8869b938d43b = class {
    constructor(user){
        this.user = user;
    }
    listUsers(aud) {
        return this.user._request("/admin/users", {
            method: "GET",
            audience: aud
        });
    }
    getUser(user) {
        return this.user._request(`/admin/users/${user.id}`);
    }
    updateUser(user, attributes = {}) {
        return this.user._request(`/admin/users/${user.id}`, {
            method: "PUT",
            body: JSON.stringify(attributes)
        });
    }
    createUser(email, password, attributes = {}) {
        attributes.email = email;
        attributes.password = password;
        return this.user._request("/admin/users", {
            method: "POST",
            body: JSON.stringify(attributes)
        });
    }
    deleteUser(user) {
        return this.user._request(`/admin/users/${user.id}`, {
            method: "DELETE"
        });
    }
};
// src/user.ts
var $cfaa407c6a1db17d$var$ExpiryMargin = 60000;
var $cfaa407c6a1db17d$var$storageKey = "gotrue.user";
var $cfaa407c6a1db17d$var$refreshPromises = {};
var $cfaa407c6a1db17d$var$currentUser = null;
var $cfaa407c6a1db17d$var$forbiddenUpdateAttributes = {
    api: 1,
    token: 1,
    audience: 1,
    url: 1
};
var $cfaa407c6a1db17d$var$forbiddenSaveAttributes = {
    api: 1
};
var $cfaa407c6a1db17d$var$isBrowser = ()=>typeof window !== "undefined";
var $cfaa407c6a1db17d$var$storageListenerActive = false;
function $cfaa407c6a1db17d$var$ensureStorageListener() {
    if (!$cfaa407c6a1db17d$var$storageListenerActive && $cfaa407c6a1db17d$var$isBrowser()) {
        $cfaa407c6a1db17d$var$storageListenerActive = true;
        window.addEventListener("storage", (event)=>{
            if (event.key === $cfaa407c6a1db17d$var$storageKey) $cfaa407c6a1db17d$var$currentUser = null;
        });
    }
}
var $cfaa407c6a1db17d$export$1f44aaf2ec115b54 = class _User {
    constructor(api, tokenResponse, audience){
        this.token = null;
        this.api = api;
        this.url = api.apiURL;
        this.audience = audience;
        this._processTokenResponse(tokenResponse);
        $cfaa407c6a1db17d$var$currentUser = this;
        $cfaa407c6a1db17d$var$ensureStorageListener();
    }
    static removeSavedSession() {
        $cfaa407c6a1db17d$var$isBrowser() && localStorage.removeItem($cfaa407c6a1db17d$var$storageKey);
    }
    static recoverSession(apiInstance) {
        $cfaa407c6a1db17d$var$ensureStorageListener();
        if ($cfaa407c6a1db17d$var$currentUser) return $cfaa407c6a1db17d$var$currentUser;
        const json = $cfaa407c6a1db17d$var$isBrowser() && localStorage.getItem($cfaa407c6a1db17d$var$storageKey);
        if (json) try {
            const data = JSON.parse(json);
            const { url: url, token: token, audience: audience } = data;
            if (!url || !token) return null;
            const api = apiInstance || new $cfaa407c6a1db17d$var$API(url, {});
            return new _User(api, token, audience)._saveUserData(data, true);
        } catch (error) {
            console.error(new Error(`Gotrue-js: Error recovering session: ${error}`));
            return null;
        }
        return null;
    }
    get admin() {
        return new $cfaa407c6a1db17d$export$c67a8869b938d43b(this);
    }
    async update(attributes) {
        const response = await this._request("/user", {
            method: "PUT",
            body: JSON.stringify(attributes)
        });
        return this._saveUserData(response)._refreshSavedSession();
    }
    jwt(forceRefresh) {
        const token = this.tokenDetails();
        if (token === null || token === void 0) return Promise.reject(new Error(`Gotrue-js: failed getting jwt access token`));
        const { expires_at: expires_at, refresh_token: refresh_token, access_token: access_token } = token;
        if (forceRefresh || expires_at - $cfaa407c6a1db17d$var$ExpiryMargin < Date.now()) return this._refreshToken(refresh_token);
        return Promise.resolve(access_token);
    }
    logout() {
        return this._request("/logout", {
            method: "POST"
        }).then(this.clearSession.bind(this)).catch(this.clearSession.bind(this));
    }
    _refreshToken(refresh_token) {
        const existingPromise = $cfaa407c6a1db17d$var$refreshPromises[refresh_token];
        if (existingPromise) return existingPromise;
        const refreshRequest = this.api.request("/token", {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            body: `grant_type=refresh_token&refresh_token=${refresh_token}`
        });
        const timeoutPromise = new Promise((_resolve, reject)=>{
            setTimeout(()=>reject(new Error("Token refresh timeout")), 3e4);
        });
        const promise = Promise.race([
            refreshRequest,
            timeoutPromise
        ]).then((response)=>{
            delete $cfaa407c6a1db17d$var$refreshPromises[refresh_token];
            this._processTokenResponse(response);
            this._refreshSavedSession();
            if (!this.token) throw new Error("Gotrue-js: Token not set after refresh");
            return this.token.access_token;
        }).catch((error)=>{
            delete $cfaa407c6a1db17d$var$refreshPromises[refresh_token];
            this.clearSession();
            throw error;
        });
        $cfaa407c6a1db17d$var$refreshPromises[refresh_token] = promise;
        return promise;
    }
    async _request(path, options = {}) {
        options.headers = options.headers || {};
        const aud = options.audience || this.audience;
        if (aud) options.headers["X-JWT-AUD"] = aud;
        try {
            const token = await this.jwt();
            return await this.api.request(path, {
                headers: Object.assign(options.headers, {
                    Authorization: `Bearer ${token}`
                }),
                ...options
            });
        } catch (error) {
            if (error instanceof $cfaa407c6a1db17d$export$21308bf12e4debfb && error.json) {
                if (error.json.msg) error.message = error.json.msg;
                else if (error.json.error) error.message = `${error.json.error}: ${error.json.error_description}`;
            }
            throw error;
        }
    }
    async getUserData() {
        const response = await this._request("/user");
        return this._saveUserData(response)._refreshSavedSession();
    }
    _saveUserData(attributes, fromStorage) {
        for(const key in attributes){
            if (key in _User.prototype || key in $cfaa407c6a1db17d$var$forbiddenUpdateAttributes) continue;
            this[key] = attributes[key];
        }
        if (fromStorage) this._fromStorage = true;
        return this;
    }
    _processTokenResponse(tokenResponse) {
        this.token = tokenResponse;
        try {
            const claims = JSON.parse($cfaa407c6a1db17d$var$urlBase64Decode(tokenResponse.access_token.split(".")[1]));
            this.token.expires_at = claims.exp * 1e3;
        } catch (error) {
            console.error(new Error(`Gotrue-js: Failed to parse tokenResponse claims: ${error}`));
        }
    }
    _refreshSavedSession() {
        if ($cfaa407c6a1db17d$var$isBrowser() && localStorage.getItem($cfaa407c6a1db17d$var$storageKey)) this._saveSession();
        return this;
    }
    get _details() {
        const userCopy = {};
        for(const key in this){
            if (key in _User.prototype || key in $cfaa407c6a1db17d$var$forbiddenSaveAttributes) continue;
            userCopy[key] = this[key];
        }
        return userCopy;
    }
    _saveSession() {
        $cfaa407c6a1db17d$var$isBrowser() && localStorage.setItem($cfaa407c6a1db17d$var$storageKey, JSON.stringify(this._details));
        return this;
    }
    tokenDetails() {
        return this.token;
    }
    clearSession() {
        _User.removeSavedSession();
        this.token = null;
        $cfaa407c6a1db17d$var$currentUser = null;
    }
};
function $cfaa407c6a1db17d$var$base64Decode(base64) {
    if (typeof atob === "function") return atob(base64);
    return $cfaa407c6a1db17d$require$Buffer.from(base64, "base64").toString("binary");
}
function $cfaa407c6a1db17d$var$urlBase64Decode(str) {
    let output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch(output.length % 4){
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw new Error("Illegal base64url string!");
    }
    const binaryString = $cfaa407c6a1db17d$var$base64Decode(output);
    try {
        const bytes = Uint8Array.from(binaryString, (char)=>char.codePointAt(0) ?? 0);
        return new TextDecoder().decode(bytes);
    } catch  {
        return binaryString;
    }
}
// src/index.ts
var $cfaa407c6a1db17d$var$HTTPRegexp = /^http:\/\//;
var $cfaa407c6a1db17d$var$defaultApiURL = `/.netlify/identity`;
var $cfaa407c6a1db17d$export$2e2bcd8739ae039 = class {
    constructor({ APIUrl: APIUrl = $cfaa407c6a1db17d$var$defaultApiURL, audience: audience = "", setCookie: setCookie = false, clientName: clientName = "gotrue-js" } = {}){
        if ($cfaa407c6a1db17d$var$HTTPRegexp.test(APIUrl)) console.warn("Warning:\n\nDO NOT USE HTTP IN PRODUCTION FOR GOTRUE EVER!\nGoTrue REQUIRES HTTPS to work securely.");
        if (audience) this.audience = audience;
        this.setCookie = setCookie;
        this.api = new $cfaa407c6a1db17d$var$API(APIUrl, {
            defaultHeaders: {
                "X-Nf-Client": clientName
            }
        });
    }
    async _request(path, options = {}) {
        options.headers = options.headers || {};
        const aud = options.audience || this.audience;
        if (aud) options.headers["X-JWT-AUD"] = aud;
        try {
            return await this.api.request(path, options);
        } catch (error) {
            if (error instanceof $cfaa407c6a1db17d$export$21308bf12e4debfb && error.json) {
                if (error.json.msg) error.message = error.json.msg;
                else if (error.json.error) error.message = `${error.json.error}: ${error.json.error_description}`;
            }
            throw error;
        }
    }
    settings() {
        return this._request("/settings");
    }
    signup(email, password, data) {
        return this._request("/signup", {
            method: "POST",
            body: JSON.stringify({
                email: email,
                password: password,
                data: data
            })
        });
    }
    login(email, password, remember) {
        this._setRememberHeaders(remember);
        return this._request("/token", {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            body: `grant_type=password&username=${encodeURIComponent(email)}&password=${encodeURIComponent(password)}`
        }).then((response)=>{
            $cfaa407c6a1db17d$export$1f44aaf2ec115b54.removeSavedSession();
            return this.createUser(response, remember);
        });
    }
    loginExternalUrl(provider) {
        return `${this.api.apiURL}/authorize?provider=${provider}`;
    }
    confirm(token, remember) {
        this._setRememberHeaders(remember);
        return this.verify("signup", token, remember);
    }
    requestPasswordRecovery(email) {
        return this._request("/recover", {
            method: "POST",
            body: JSON.stringify({
                email: email
            })
        });
    }
    recover(token, remember) {
        this._setRememberHeaders(remember);
        return this.verify("recovery", token, remember);
    }
    acceptInvite(token, password, remember) {
        this._setRememberHeaders(remember);
        return this._request("/verify", {
            method: "POST",
            body: JSON.stringify({
                token: token,
                password: password,
                type: "signup"
            })
        }).then((response)=>this.createUser(response, remember));
    }
    acceptInviteExternalUrl(provider, token) {
        return `${this.api.apiURL}/authorize?provider=${provider}&invite_token=${token}`;
    }
    createUser(tokenResponse, remember = false) {
        this._setRememberHeaders(remember);
        const user = new $cfaa407c6a1db17d$export$1f44aaf2ec115b54(this.api, tokenResponse, this.audience || "");
        return user.getUserData().then((userData)=>{
            if (remember) userData._saveSession();
            return userData;
        });
    }
    currentUser() {
        const user = $cfaa407c6a1db17d$export$1f44aaf2ec115b54.recoverSession(this.api);
        user && this._setRememberHeaders(user._fromStorage);
        return user;
    }
    async validateCurrentSession() {
        const user = this.currentUser();
        if (!user) return null;
        try {
            return await user.getUserData();
        } catch  {
            user.clearSession();
            return null;
        }
    }
    verify(type, token, remember) {
        this._setRememberHeaders(remember);
        return this._request("/verify", {
            method: "POST",
            body: JSON.stringify({
                token: token,
                type: type
            })
        }).then((response)=>this.createUser(response, remember));
    }
    _setRememberHeaders(remember) {
        if (this.setCookie) {
            this.api.defaultHeaders = this.api.defaultHeaders || {};
            this.api.defaultHeaders["X-Use-Cookie"] = remember ? "1" : "session";
        }
    }
};
if (typeof window !== "undefined") window.GoTrue = $cfaa407c6a1db17d$export$2e2bcd8739ae039;


var $a632bf13a3aa851a$var$__require = /* @__PURE__ */ ((x)=>undefined)(function(x) {
    return undefined(this, arguments);
});
// src/types.ts
var $a632bf13a3aa851a$var$AUTH_PROVIDERS = [
    "google",
    "github",
    "gitlab",
    "bitbucket",
    "facebook",
    "email"
];
// src/errors.ts
var $a632bf13a3aa851a$export$145273558d58e0ac = class _AuthError extends Error {
    constructor(message, status, options){
        super(message);
        this.name = "AuthError";
        this.status = status;
        if (options && "cause" in options) this.cause = options.cause;
    }
    static from(error) {
        if (error instanceof _AuthError) return error;
        const message = error instanceof Error ? error.message : String(error);
        return new _AuthError(message, void 0, {
            cause: error
        });
    }
};
var $a632bf13a3aa851a$export$a076d93d6ab4b240 = class extends Error {
    constructor(message = "Netlify Identity is not available."){
        super(message);
        this.name = "MissingIdentityError";
    }
};
// src/environment.ts
var $a632bf13a3aa851a$var$IDENTITY_PATH = "/.netlify/identity";
var $a632bf13a3aa851a$var$goTrueClient = null;
var $a632bf13a3aa851a$var$cachedApiUrl;
var $a632bf13a3aa851a$var$warnedMissingUrl = false;
var $a632bf13a3aa851a$var$isBrowser = ()=>typeof window !== "undefined" && typeof window.location !== "undefined";
var $a632bf13a3aa851a$var$discoverApiUrl = ()=>{
    if ($a632bf13a3aa851a$var$cachedApiUrl !== void 0) return $a632bf13a3aa851a$var$cachedApiUrl;
    if ($a632bf13a3aa851a$var$isBrowser()) $a632bf13a3aa851a$var$cachedApiUrl = `${window.location.origin}${$a632bf13a3aa851a$var$IDENTITY_PATH}`;
    else {
        const identityContext = $a632bf13a3aa851a$var$getIdentityContext();
        if (identityContext?.url) $a632bf13a3aa851a$var$cachedApiUrl = identityContext.url;
        else if (globalThis.Netlify?.context?.url) $a632bf13a3aa851a$var$cachedApiUrl = new URL($a632bf13a3aa851a$var$IDENTITY_PATH, globalThis.Netlify.context.url).href;
    }
    return $a632bf13a3aa851a$var$cachedApiUrl ?? null;
};
var $a632bf13a3aa851a$var$getGoTrueClient = ()=>{
    if ($a632bf13a3aa851a$var$goTrueClient) return $a632bf13a3aa851a$var$goTrueClient;
    const apiUrl = $a632bf13a3aa851a$var$discoverApiUrl();
    if (!apiUrl) {
        if (!$a632bf13a3aa851a$var$warnedMissingUrl) {
            console.warn("@netlify/identity: Could not determine the Identity endpoint URL. Make sure your site has Netlify Identity enabled, or run your app with `netlify dev`.");
            $a632bf13a3aa851a$var$warnedMissingUrl = true;
        }
        return null;
    }
    $a632bf13a3aa851a$var$goTrueClient = new (0, $cfaa407c6a1db17d$export$2e2bcd8739ae039)({
        APIUrl: apiUrl,
        setCookie: false
    });
    return $a632bf13a3aa851a$var$goTrueClient;
};
var $a632bf13a3aa851a$var$getClient = ()=>{
    const client = $a632bf13a3aa851a$var$getGoTrueClient();
    if (!client) throw new $a632bf13a3aa851a$export$a076d93d6ab4b240();
    return client;
};
var $a632bf13a3aa851a$var$getIdentityContext = ()=>{
    const identityContext = globalThis.netlifyIdentityContext;
    if (identityContext?.url) return {
        url: identityContext.url,
        token: identityContext.token
    };
    if (globalThis.Netlify?.context?.url) return {
        url: new URL($a632bf13a3aa851a$var$IDENTITY_PATH, globalThis.Netlify.context.url).href
    };
    const siteUrl = void 0;
    if (siteUrl) return {
        url: new URL($a632bf13a3aa851a$var$IDENTITY_PATH, siteUrl).href
    };
    return null;
};
// src/cookies.ts
var $a632bf13a3aa851a$var$NF_JWT_COOKIE = "nf_jwt";
var $a632bf13a3aa851a$var$NF_REFRESH_COOKIE = "nf_refresh";
var $a632bf13a3aa851a$var$getCookie = (name)=>{
    if (typeof document === "undefined") return null;
    const match = new RegExp(`(?:^|; )${name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}=([^;]*)`).exec(document.cookie);
    if (!match) return null;
    try {
        return decodeURIComponent(match[1]);
    } catch  {
        return match[1];
    }
};
var $a632bf13a3aa851a$var$setAuthCookies = (cookies, accessToken, refreshToken)=>{
    cookies.set({
        name: $a632bf13a3aa851a$var$NF_JWT_COOKIE,
        value: accessToken,
        httpOnly: false,
        secure: true,
        path: "/",
        sameSite: "Lax"
    });
    if (refreshToken) cookies.set({
        name: $a632bf13a3aa851a$var$NF_REFRESH_COOKIE,
        value: refreshToken,
        httpOnly: false,
        secure: true,
        path: "/",
        sameSite: "Lax"
    });
};
var $a632bf13a3aa851a$var$deleteAuthCookies = (cookies)=>{
    cookies.delete($a632bf13a3aa851a$var$NF_JWT_COOKIE);
    cookies.delete($a632bf13a3aa851a$var$NF_REFRESH_COOKIE);
};
var $a632bf13a3aa851a$var$setBrowserAuthCookies = (accessToken, refreshToken)=>{
    if (typeof document === "undefined") return;
    document.cookie = `${$a632bf13a3aa851a$var$NF_JWT_COOKIE}=${encodeURIComponent(accessToken)}; path=/; secure; samesite=lax`;
    if (refreshToken) document.cookie = `${$a632bf13a3aa851a$var$NF_REFRESH_COOKIE}=${encodeURIComponent(refreshToken)}; path=/; secure; samesite=lax`;
};
var $a632bf13a3aa851a$var$deleteBrowserAuthCookies = ()=>{
    if (typeof document === "undefined") return;
    document.cookie = `${$a632bf13a3aa851a$var$NF_JWT_COOKIE}=; path=/; secure; samesite=lax; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    document.cookie = `${$a632bf13a3aa851a$var$NF_REFRESH_COOKIE}=; path=/; secure; samesite=lax; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
};
var $a632bf13a3aa851a$var$getServerCookie = (name)=>{
    const cookies = globalThis.Netlify?.context?.cookies;
    if (!cookies || typeof cookies.get !== "function") return null;
    return cookies.get(name) ?? null;
};
// src/nextjs.ts
var $a632bf13a3aa851a$var$nextHeadersFn;
var $a632bf13a3aa851a$var$triggerNextjsDynamic = ()=>{
    if ($a632bf13a3aa851a$var$nextHeadersFn === null) return;
    if ($a632bf13a3aa851a$var$nextHeadersFn === void 0) try {
        if (typeof $a632bf13a3aa851a$var$__require === "undefined") {
            $a632bf13a3aa851a$var$nextHeadersFn = null;
            return;
        }
        const mod = $a632bf13a3aa851a$var$__require("next/headers");
        $a632bf13a3aa851a$var$nextHeadersFn = mod.headers;
    } catch  {
        $a632bf13a3aa851a$var$nextHeadersFn = null;
        return;
    }
    const fn = $a632bf13a3aa851a$var$nextHeadersFn;
    if (!fn) return;
    try {
        fn();
    } catch (e) {
        if (e instanceof Error && ("digest" in e || /bail\s*out.*prerende/i.test(e.message))) throw e;
    }
};
// src/fetch.ts
var $a632bf13a3aa851a$var$DEFAULT_TIMEOUT_MS = 5e3;
var $a632bf13a3aa851a$var$fetchWithTimeout = async (url, options = {}, timeoutMs = $a632bf13a3aa851a$var$DEFAULT_TIMEOUT_MS)=>{
    const controller = new AbortController();
    const timer = setTimeout(()=>{
        controller.abort();
    }, timeoutMs);
    try {
        return await fetch(url, {
            ...options,
            signal: controller.signal
        });
    } catch (error) {
        if (error instanceof Error && error.name === "AbortError") {
            const pathname = new URL(url).pathname;
            throw new $a632bf13a3aa851a$export$145273558d58e0ac(`Identity request to ${pathname} timed out after ${String(timeoutMs)}ms`);
        }
        throw error;
    } finally{
        clearTimeout(timer);
    }
};
// src/events.ts
var $a632bf13a3aa851a$export$8e89f65f64ee884c = {
    LOGIN: "login",
    LOGOUT: "logout",
    TOKEN_REFRESH: "token_refresh",
    USER_UPDATED: "user_updated",
    RECOVERY: "recovery"
};
var $a632bf13a3aa851a$var$GOTRUE_STORAGE_KEY = "gotrue.user";
var $a632bf13a3aa851a$var$listeners = /* @__PURE__ */ new Set();
var $a632bf13a3aa851a$var$emitAuthEvent = (event, user)=>{
    for (const listener of $a632bf13a3aa851a$var$listeners)try {
        listener(event, user);
    } catch  {}
};
var $a632bf13a3aa851a$var$storageListenerAttached = false;
var $a632bf13a3aa851a$var$attachStorageListener = ()=>{
    if ($a632bf13a3aa851a$var$storageListenerAttached || !$a632bf13a3aa851a$var$isBrowser()) return;
    $a632bf13a3aa851a$var$storageListenerAttached = true;
    window.addEventListener("storage", (event)=>{
        if (event.key !== $a632bf13a3aa851a$var$GOTRUE_STORAGE_KEY) return;
        if (event.newValue) {
            const client = $a632bf13a3aa851a$var$getGoTrueClient();
            const currentUser = client?.currentUser();
            $a632bf13a3aa851a$var$emitAuthEvent($a632bf13a3aa851a$export$8e89f65f64ee884c.LOGIN, currentUser ? $a632bf13a3aa851a$var$toUser(currentUser) : null);
        } else $a632bf13a3aa851a$var$emitAuthEvent($a632bf13a3aa851a$export$8e89f65f64ee884c.LOGOUT, null);
    });
};
var $a632bf13a3aa851a$export$72ecacea0ae0358c = (callback)=>{
    if (!$a632bf13a3aa851a$var$isBrowser()) return ()=>{};
    $a632bf13a3aa851a$var$listeners.add(callback);
    $a632bf13a3aa851a$var$attachStorageListener();
    return ()=>{
        $a632bf13a3aa851a$var$listeners.delete(callback);
    };
};
// src/refresh.ts
var $a632bf13a3aa851a$var$REFRESH_MARGIN_S = 60;
var $a632bf13a3aa851a$var$refreshTimer = null;
var $a632bf13a3aa851a$var$startTokenRefresh = ()=>{
    if (!$a632bf13a3aa851a$var$isBrowser()) return;
    $a632bf13a3aa851a$var$stopTokenRefresh();
    const client = $a632bf13a3aa851a$var$getGoTrueClient();
    const user = client?.currentUser();
    if (!user) return;
    const token = user.tokenDetails();
    if (!token?.expires_at) return;
    const nowS = Math.floor(Date.now() / 1e3);
    const expiresAtS = typeof token.expires_at === "number" && token.expires_at > 1e12 ? Math.floor(token.expires_at / 1e3) : token.expires_at;
    const delayMs = Math.max(0, expiresAtS - nowS - $a632bf13a3aa851a$var$REFRESH_MARGIN_S) * 1e3;
    $a632bf13a3aa851a$var$refreshTimer = setTimeout(()=>{
        (async ()=>{
            try {
                const freshJwt = await user.jwt(true);
                const freshDetails = user.tokenDetails();
                $a632bf13a3aa851a$var$setBrowserAuthCookies(freshJwt, freshDetails?.refresh_token);
                $a632bf13a3aa851a$var$emitAuthEvent($a632bf13a3aa851a$export$8e89f65f64ee884c.TOKEN_REFRESH, $a632bf13a3aa851a$var$toUser(user));
                $a632bf13a3aa851a$var$startTokenRefresh();
            } catch  {
                $a632bf13a3aa851a$var$stopTokenRefresh();
            }
        })();
    }, delayMs);
};
var $a632bf13a3aa851a$var$stopTokenRefresh = ()=>{
    if ($a632bf13a3aa851a$var$refreshTimer !== null) {
        clearTimeout($a632bf13a3aa851a$var$refreshTimer);
        $a632bf13a3aa851a$var$refreshTimer = null;
    }
};
var $a632bf13a3aa851a$export$296522b9b583854e = async ()=>{
    if ($a632bf13a3aa851a$var$isBrowser()) {
        const client = $a632bf13a3aa851a$var$getGoTrueClient();
        const user = client?.currentUser();
        if (!user) return null;
        const details = user.tokenDetails();
        if (details?.expires_at) {
            const nowS2 = Math.floor(Date.now() / 1e3);
            const expiresAtS = typeof details.expires_at === "number" && details.expires_at > 1e12 ? Math.floor(details.expires_at / 1e3) : details.expires_at;
            if (expiresAtS - nowS2 > $a632bf13a3aa851a$var$REFRESH_MARGIN_S) return null;
        }
        try {
            const jwt = await user.jwt(true);
            $a632bf13a3aa851a$var$setBrowserAuthCookies(jwt, user.tokenDetails()?.refresh_token);
            $a632bf13a3aa851a$var$emitAuthEvent($a632bf13a3aa851a$export$8e89f65f64ee884c.TOKEN_REFRESH, $a632bf13a3aa851a$var$toUser(user));
            $a632bf13a3aa851a$var$startTokenRefresh();
            return jwt;
        } catch  {
            $a632bf13a3aa851a$var$stopTokenRefresh();
            return null;
        }
    }
    const accessToken = $a632bf13a3aa851a$var$getServerCookie($a632bf13a3aa851a$var$NF_JWT_COOKIE);
    const refreshToken = $a632bf13a3aa851a$var$getServerCookie($a632bf13a3aa851a$var$NF_REFRESH_COOKIE);
    if (!accessToken || !refreshToken) return null;
    const decoded = $a632bf13a3aa851a$var$decodeJwtPayload(accessToken);
    if (!decoded?.exp) return null;
    const nowS = Math.floor(Date.now() / 1e3);
    if (decoded.exp - nowS > $a632bf13a3aa851a$var$REFRESH_MARGIN_S) return null;
    const ctx = $a632bf13a3aa851a$var$getIdentityContext();
    const identityUrl = ctx?.url ?? (globalThis.Netlify?.context?.url ? new URL($a632bf13a3aa851a$var$IDENTITY_PATH, globalThis.Netlify.context.url).href : null);
    if (!identityUrl) throw new $a632bf13a3aa851a$export$145273558d58e0ac("Could not determine the Identity endpoint URL for token refresh");
    let res;
    try {
        res = await $a632bf13a3aa851a$var$fetchWithTimeout(`${identityUrl}/token`, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            body: new URLSearchParams({
                grant_type: "refresh_token",
                refresh_token: refreshToken
            }).toString()
        });
    } catch (error) {
        throw $a632bf13a3aa851a$export$145273558d58e0ac.from(error);
    }
    if (!res.ok) {
        const errorBody = await res.json().catch(()=>({}));
        if (res.status === 401 || res.status === 400) {
            const cookies2 = globalThis.Netlify?.context?.cookies;
            if (cookies2) $a632bf13a3aa851a$var$deleteAuthCookies(cookies2);
            return null;
        }
        throw new $a632bf13a3aa851a$export$145273558d58e0ac(errorBody.msg ?? `Token refresh failed (${String(res.status)})`, res.status);
    }
    const data = await res.json();
    const cookies = globalThis.Netlify?.context?.cookies;
    if (cookies) $a632bf13a3aa851a$var$setAuthCookies(cookies, data.access_token, data.refresh_token);
    return data.access_token;
};
// src/auth.ts
var $a632bf13a3aa851a$var$getCookies = ()=>{
    const cookies = globalThis.Netlify?.context?.cookies;
    if (!cookies) throw new $a632bf13a3aa851a$export$145273558d58e0ac("Server-side auth requires Netlify Functions runtime");
    return cookies;
};
var $a632bf13a3aa851a$var$getServerIdentityUrl = ()=>{
    const ctx = $a632bf13a3aa851a$var$getIdentityContext();
    if (!ctx?.url) throw new $a632bf13a3aa851a$export$145273558d58e0ac("Could not determine the Identity endpoint URL on the server");
    return ctx.url;
};
var $a632bf13a3aa851a$var$persistSession = true;
var $a632bf13a3aa851a$export$596d806903d1f59e = async (email, password)=>{
    if (!$a632bf13a3aa851a$var$isBrowser()) {
        const identityUrl = $a632bf13a3aa851a$var$getServerIdentityUrl();
        const cookies = $a632bf13a3aa851a$var$getCookies();
        const body = new URLSearchParams({
            grant_type: "password",
            username: email,
            password: password
        });
        let res;
        try {
            res = await $a632bf13a3aa851a$var$fetchWithTimeout(`${identityUrl}/token`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                body: body.toString()
            });
        } catch (error) {
            throw $a632bf13a3aa851a$export$145273558d58e0ac.from(error);
        }
        if (!res.ok) {
            const errorBody = await res.json().catch(()=>({}));
            throw new $a632bf13a3aa851a$export$145273558d58e0ac(errorBody.msg ?? errorBody.error_description ?? `Login failed (${String(res.status)})`, res.status);
        }
        const data = await res.json();
        const accessToken = data.access_token;
        let userRes;
        try {
            userRes = await $a632bf13a3aa851a$var$fetchWithTimeout(`${identityUrl}/user`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            });
        } catch (error) {
            throw $a632bf13a3aa851a$export$145273558d58e0ac.from(error);
        }
        if (!userRes.ok) {
            const errorBody = await userRes.json().catch(()=>({}));
            throw new $a632bf13a3aa851a$export$145273558d58e0ac(errorBody.msg ?? `Failed to fetch user data (${String(userRes.status)})`, userRes.status);
        }
        const userData = await userRes.json();
        const user = $a632bf13a3aa851a$var$toUser(userData);
        $a632bf13a3aa851a$var$setAuthCookies(cookies, accessToken, data.refresh_token);
        return user;
    }
    const client = $a632bf13a3aa851a$var$getClient();
    try {
        const gotrueUser = await client.login(email, password, $a632bf13a3aa851a$var$persistSession);
        const jwt = await gotrueUser.jwt();
        $a632bf13a3aa851a$var$setBrowserAuthCookies(jwt, gotrueUser.tokenDetails()?.refresh_token);
        const user = $a632bf13a3aa851a$var$toUser(gotrueUser);
        $a632bf13a3aa851a$var$startTokenRefresh();
        $a632bf13a3aa851a$var$emitAuthEvent($a632bf13a3aa851a$export$8e89f65f64ee884c.LOGIN, user);
        return user;
    } catch (error) {
        throw $a632bf13a3aa851a$export$145273558d58e0ac.from(error);
    }
};
var $a632bf13a3aa851a$export$7200a869094fec36 = async (email, password, data)=>{
    if (!$a632bf13a3aa851a$var$isBrowser()) {
        const identityUrl = $a632bf13a3aa851a$var$getServerIdentityUrl();
        const cookies = $a632bf13a3aa851a$var$getCookies();
        let res;
        try {
            res = await $a632bf13a3aa851a$var$fetchWithTimeout(`${identityUrl}/signup`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email: email,
                    password: password,
                    data: data
                })
            });
        } catch (error) {
            throw $a632bf13a3aa851a$export$145273558d58e0ac.from(error);
        }
        if (!res.ok) {
            const errorBody = await res.json().catch(()=>({}));
            throw new $a632bf13a3aa851a$export$145273558d58e0ac(errorBody.msg ?? `Signup failed (${String(res.status)})`, res.status);
        }
        const responseData = await res.json();
        const user = $a632bf13a3aa851a$var$toUser(responseData);
        if (responseData.confirmed_at) {
            const accessToken = responseData.access_token;
            if (accessToken) $a632bf13a3aa851a$var$setAuthCookies(cookies, accessToken, responseData.refresh_token);
        }
        return user;
    }
    const client = $a632bf13a3aa851a$var$getClient();
    try {
        const response = await client.signup(email, password, data);
        const user = $a632bf13a3aa851a$var$toUser(response);
        if (response.confirmed_at) {
            const jwt = await response.jwt?.();
            if (jwt) {
                const refreshToken = response.tokenDetails?.()?.refresh_token;
                $a632bf13a3aa851a$var$setBrowserAuthCookies(jwt, refreshToken);
            }
            $a632bf13a3aa851a$var$startTokenRefresh();
            $a632bf13a3aa851a$var$emitAuthEvent($a632bf13a3aa851a$export$8e89f65f64ee884c.LOGIN, user);
        }
        return user;
    } catch (error) {
        throw $a632bf13a3aa851a$export$145273558d58e0ac.from(error);
    }
};
var $a632bf13a3aa851a$export$a0973bcfe11b05c9 = async ()=>{
    if (!$a632bf13a3aa851a$var$isBrowser()) {
        const identityUrl = $a632bf13a3aa851a$var$getServerIdentityUrl();
        const cookies = $a632bf13a3aa851a$var$getCookies();
        const jwt = cookies.get($a632bf13a3aa851a$var$NF_JWT_COOKIE);
        if (jwt) try {
            await $a632bf13a3aa851a$var$fetchWithTimeout(`${identityUrl}/logout`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${jwt}`
                }
            });
        } catch  {}
        $a632bf13a3aa851a$var$deleteAuthCookies(cookies);
        return;
    }
    const client = $a632bf13a3aa851a$var$getClient();
    try {
        const currentUser = client.currentUser();
        if (currentUser) await currentUser.logout();
        $a632bf13a3aa851a$var$deleteBrowserAuthCookies();
        $a632bf13a3aa851a$var$stopTokenRefresh();
        $a632bf13a3aa851a$var$emitAuthEvent($a632bf13a3aa851a$export$8e89f65f64ee884c.LOGOUT, null);
    } catch (error) {
        throw $a632bf13a3aa851a$export$145273558d58e0ac.from(error);
    }
};
var $a632bf13a3aa851a$export$e2d494117d1616e8 = (provider)=>{
    if (!$a632bf13a3aa851a$var$isBrowser()) throw new $a632bf13a3aa851a$export$145273558d58e0ac("oauthLogin() is only available in the browser");
    const client = $a632bf13a3aa851a$var$getClient();
    window.location.href = client.loginExternalUrl(provider);
    throw new $a632bf13a3aa851a$export$145273558d58e0ac("Redirecting to OAuth provider");
};
var $a632bf13a3aa851a$export$213a2dc2015f93c1 = async ()=>{
    if (!$a632bf13a3aa851a$var$isBrowser()) return null;
    const hash = window.location.hash.substring(1);
    if (!hash) return null;
    const client = $a632bf13a3aa851a$var$getClient();
    const params = new URLSearchParams(hash);
    try {
        const accessToken = params.get("access_token");
        if (accessToken) return await $a632bf13a3aa851a$var$handleOAuthCallback(client, params, accessToken);
        const confirmationToken = params.get("confirmation_token");
        if (confirmationToken) return await $a632bf13a3aa851a$var$handleConfirmationCallback(client, confirmationToken);
        const recoveryToken = params.get("recovery_token");
        if (recoveryToken) return await $a632bf13a3aa851a$var$handleRecoveryCallback(client, recoveryToken);
        const inviteToken = params.get("invite_token");
        if (inviteToken) return $a632bf13a3aa851a$var$handleInviteCallback(inviteToken);
        const emailChangeToken = params.get("email_change_token");
        if (emailChangeToken) return await $a632bf13a3aa851a$var$handleEmailChangeCallback(client, emailChangeToken);
        return null;
    } catch (error) {
        if (error instanceof $a632bf13a3aa851a$export$145273558d58e0ac) throw error;
        throw $a632bf13a3aa851a$export$145273558d58e0ac.from(error);
    }
};
var $a632bf13a3aa851a$var$handleOAuthCallback = async (client, params, accessToken)=>{
    const refreshToken = params.get("refresh_token") ?? "";
    const expiresIn = parseInt(params.get("expires_in") ?? "", 10);
    const expiresAt = parseInt(params.get("expires_at") ?? "", 10);
    const gotrueUser = await client.createUser({
        access_token: accessToken,
        token_type: params.get("token_type") ?? "bearer",
        expires_in: isFinite(expiresIn) ? expiresIn : 3600,
        expires_at: isFinite(expiresAt) ? expiresAt : Math.floor(Date.now() / 1e3) + 3600,
        refresh_token: refreshToken
    }, $a632bf13a3aa851a$var$persistSession);
    $a632bf13a3aa851a$var$setBrowserAuthCookies(accessToken, refreshToken || void 0);
    const user = $a632bf13a3aa851a$var$toUser(gotrueUser);
    $a632bf13a3aa851a$var$startTokenRefresh();
    $a632bf13a3aa851a$var$clearHash();
    $a632bf13a3aa851a$var$emitAuthEvent($a632bf13a3aa851a$export$8e89f65f64ee884c.LOGIN, user);
    return {
        type: "oauth",
        user: user
    };
};
var $a632bf13a3aa851a$var$handleConfirmationCallback = async (client, token)=>{
    const gotrueUser = await client.confirm(token, $a632bf13a3aa851a$var$persistSession);
    const jwt = await gotrueUser.jwt();
    $a632bf13a3aa851a$var$setBrowserAuthCookies(jwt, gotrueUser.tokenDetails()?.refresh_token);
    const user = $a632bf13a3aa851a$var$toUser(gotrueUser);
    $a632bf13a3aa851a$var$startTokenRefresh();
    $a632bf13a3aa851a$var$clearHash();
    $a632bf13a3aa851a$var$emitAuthEvent($a632bf13a3aa851a$export$8e89f65f64ee884c.LOGIN, user);
    return {
        type: "confirmation",
        user: user
    };
};
var $a632bf13a3aa851a$var$handleRecoveryCallback = async (client, token)=>{
    const gotrueUser = await client.recover(token, $a632bf13a3aa851a$var$persistSession);
    const jwt = await gotrueUser.jwt();
    $a632bf13a3aa851a$var$setBrowserAuthCookies(jwt, gotrueUser.tokenDetails()?.refresh_token);
    const user = $a632bf13a3aa851a$var$toUser(gotrueUser);
    $a632bf13a3aa851a$var$startTokenRefresh();
    $a632bf13a3aa851a$var$clearHash();
    $a632bf13a3aa851a$var$emitAuthEvent($a632bf13a3aa851a$export$8e89f65f64ee884c.RECOVERY, user);
    return {
        type: "recovery",
        user: user
    };
};
var $a632bf13a3aa851a$var$handleInviteCallback = (token)=>{
    $a632bf13a3aa851a$var$clearHash();
    return {
        type: "invite",
        user: null,
        token: token
    };
};
var $a632bf13a3aa851a$var$handleEmailChangeCallback = async (client, emailChangeToken)=>{
    const currentUser = client.currentUser();
    if (!currentUser) throw new $a632bf13a3aa851a$export$145273558d58e0ac("Email change verification requires an active browser session");
    const jwt = await currentUser.jwt();
    const identityUrl = `${window.location.origin}${$a632bf13a3aa851a$var$IDENTITY_PATH}`;
    const emailChangeRes = await fetch(`${identityUrl}/user`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt}`
        },
        body: JSON.stringify({
            email_change_token: emailChangeToken
        })
    });
    if (!emailChangeRes.ok) {
        const errorBody = await emailChangeRes.json().catch(()=>({}));
        throw new $a632bf13a3aa851a$export$145273558d58e0ac(errorBody.msg ?? `Email change verification failed (${String(emailChangeRes.status)})`, emailChangeRes.status);
    }
    const emailChangeData = await emailChangeRes.json();
    const user = $a632bf13a3aa851a$var$toUser(emailChangeData);
    $a632bf13a3aa851a$var$clearHash();
    $a632bf13a3aa851a$var$emitAuthEvent($a632bf13a3aa851a$export$8e89f65f64ee884c.USER_UPDATED, user);
    return {
        type: "email_change",
        user: user
    };
};
var $a632bf13a3aa851a$var$clearHash = ()=>{
    history.replaceState(null, "", window.location.pathname + window.location.search);
};
var $a632bf13a3aa851a$export$5d5568583ad98cbc = async ()=>{
    if (!$a632bf13a3aa851a$var$isBrowser()) return null;
    const client = $a632bf13a3aa851a$var$getClient();
    const currentUser = client.currentUser();
    if (currentUser) {
        $a632bf13a3aa851a$var$startTokenRefresh();
        return $a632bf13a3aa851a$var$toUser(currentUser);
    }
    const accessToken = $a632bf13a3aa851a$var$getCookie($a632bf13a3aa851a$var$NF_JWT_COOKIE);
    if (!accessToken) return null;
    const refreshToken = $a632bf13a3aa851a$var$getCookie($a632bf13a3aa851a$var$NF_REFRESH_COOKIE) ?? "";
    const decoded = $a632bf13a3aa851a$var$decodeJwtPayload(accessToken);
    const expiresAt = decoded?.exp ?? Math.floor(Date.now() / 1e3) + 3600;
    const expiresIn = Math.max(0, expiresAt - Math.floor(Date.now() / 1e3));
    let gotrueUser;
    try {
        gotrueUser = await client.createUser({
            access_token: accessToken,
            token_type: "bearer",
            expires_in: expiresIn,
            expires_at: expiresAt,
            refresh_token: refreshToken
        }, $a632bf13a3aa851a$var$persistSession);
    } catch  {
        $a632bf13a3aa851a$var$deleteBrowserAuthCookies();
        return null;
    }
    const user = $a632bf13a3aa851a$var$toUser(gotrueUser);
    $a632bf13a3aa851a$var$startTokenRefresh();
    $a632bf13a3aa851a$var$emitAuthEvent($a632bf13a3aa851a$export$8e89f65f64ee884c.LOGIN, user);
    return user;
};
// src/user.ts
var $a632bf13a3aa851a$var$toAuthProvider = (value)=>typeof value === "string" && $a632bf13a3aa851a$var$AUTH_PROVIDERS.includes(value) ? value : void 0;
var $a632bf13a3aa851a$var$toOptionalString = (value)=>typeof value === "string" && value !== "" ? value : void 0;
var $a632bf13a3aa851a$var$toRoles = (appMeta)=>{
    const roles = appMeta.roles;
    if (Array.isArray(roles) && roles.every((r)=>typeof r === "string")) return roles;
    return void 0;
};
var $a632bf13a3aa851a$var$toUser = (userData)=>{
    const userMeta = userData.user_metadata ?? {};
    const appMeta = userData.app_metadata ?? {};
    const name = userMeta.full_name ?? userMeta.name;
    const pictureUrl = userMeta.avatar_url;
    return {
        id: userData.id,
        email: userData.email,
        confirmedAt: $a632bf13a3aa851a$var$toOptionalString(userData.confirmed_at),
        createdAt: userData.created_at,
        updatedAt: userData.updated_at,
        role: $a632bf13a3aa851a$var$toOptionalString(userData.role),
        provider: $a632bf13a3aa851a$var$toAuthProvider(appMeta.provider),
        name: typeof name === "string" ? name : void 0,
        pictureUrl: typeof pictureUrl === "string" ? pictureUrl : void 0,
        roles: $a632bf13a3aa851a$var$toRoles(appMeta),
        invitedAt: $a632bf13a3aa851a$var$toOptionalString(userData.invited_at),
        confirmationSentAt: $a632bf13a3aa851a$var$toOptionalString(userData.confirmation_sent_at),
        recoverySentAt: $a632bf13a3aa851a$var$toOptionalString(userData.recovery_sent_at),
        pendingEmail: $a632bf13a3aa851a$var$toOptionalString(userData.new_email),
        emailChangeSentAt: $a632bf13a3aa851a$var$toOptionalString(userData.email_change_sent_at),
        lastSignInAt: $a632bf13a3aa851a$var$toOptionalString(userData.last_sign_in_at),
        userMetadata: userMeta,
        appMetadata: appMeta
    };
};
var $a632bf13a3aa851a$var$claimsToUser = (claims)=>{
    const appMeta = claims.app_metadata ?? {};
    const userMeta = claims.user_metadata ?? {};
    const name = userMeta.full_name ?? userMeta.name;
    const pictureUrl = userMeta.avatar_url;
    return {
        id: claims.sub ?? "",
        email: claims.email,
        provider: $a632bf13a3aa851a$var$toAuthProvider(appMeta.provider),
        name: typeof name === "string" ? name : void 0,
        pictureUrl: typeof pictureUrl === "string" ? pictureUrl : void 0,
        roles: $a632bf13a3aa851a$var$toRoles(appMeta),
        userMetadata: userMeta,
        appMetadata: appMeta
    };
};
var $a632bf13a3aa851a$var$decodeJwtPayload = (token)=>{
    try {
        const parts = token.split(".");
        if (parts.length !== 3) return null;
        const payload = atob(parts[1].replace(/-/g, "+").replace(/_/g, "/"));
        return JSON.parse(payload);
    } catch  {
        return null;
    }
};
var $a632bf13a3aa851a$var$fetchFullUser = async (identityUrl, jwt)=>{
    try {
        const res = await $a632bf13a3aa851a$var$fetchWithTimeout(`${identityUrl}/user`, {
            headers: {
                Authorization: `Bearer ${jwt}`
            }
        });
        if (!res.ok) return null;
        const userData = await res.json();
        return $a632bf13a3aa851a$var$toUser(userData);
    } catch  {
        return null;
    }
};
var $a632bf13a3aa851a$var$resolveIdentityUrl = ()=>{
    const identityContext = $a632bf13a3aa851a$var$getIdentityContext();
    if (identityContext?.url) return identityContext.url;
    if (globalThis.Netlify?.context?.url) return new URL($a632bf13a3aa851a$var$IDENTITY_PATH, globalThis.Netlify.context.url).href;
    const siteUrl = void 0;
    if (siteUrl) return new URL($a632bf13a3aa851a$var$IDENTITY_PATH, siteUrl).href;
    return null;
};
var $a632bf13a3aa851a$export$7cbf767827cd68ba = async ()=>{
    if ($a632bf13a3aa851a$var$isBrowser()) {
        const client = $a632bf13a3aa851a$var$getGoTrueClient();
        const currentUser = client?.currentUser() ?? null;
        if (currentUser) {
            const jwt2 = $a632bf13a3aa851a$var$getCookie($a632bf13a3aa851a$var$NF_JWT_COOKIE);
            if (!jwt2) {
                try {
                    currentUser.clearSession();
                } catch  {}
                return null;
            }
            $a632bf13a3aa851a$var$startTokenRefresh();
            return $a632bf13a3aa851a$var$toUser(currentUser);
        }
        const jwt = $a632bf13a3aa851a$var$getCookie($a632bf13a3aa851a$var$NF_JWT_COOKIE);
        if (!jwt) return null;
        const claims2 = $a632bf13a3aa851a$var$decodeJwtPayload(jwt);
        if (!claims2) return null;
        const hydrated = await $a632bf13a3aa851a$export$5d5568583ad98cbc();
        return hydrated ?? null;
    }
    $a632bf13a3aa851a$var$triggerNextjsDynamic();
    const identityContext = globalThis.netlifyIdentityContext;
    const serverJwt = identityContext?.token ?? $a632bf13a3aa851a$var$getServerCookie($a632bf13a3aa851a$var$NF_JWT_COOKIE);
    if (serverJwt) {
        const identityUrl = $a632bf13a3aa851a$var$resolveIdentityUrl();
        if (identityUrl) {
            const fullUser = await $a632bf13a3aa851a$var$fetchFullUser(identityUrl, serverJwt);
            if (fullUser) return fullUser;
        }
    }
    const claims = identityContext?.user ?? null;
    return claims ? $a632bf13a3aa851a$var$claimsToUser(claims) : null;
};
var $a632bf13a3aa851a$export$83d11f23a23d4a7c = async ()=>await $a632bf13a3aa851a$export$7cbf767827cd68ba() !== null;
// src/config.ts
var $a632bf13a3aa851a$export$cbb741972c0c34ea = ()=>{
    if ($a632bf13a3aa851a$var$isBrowser()) return {
        url: `${window.location.origin}${$a632bf13a3aa851a$var$IDENTITY_PATH}`
    };
    return $a632bf13a3aa851a$var$getIdentityContext();
};
var $a632bf13a3aa851a$export$4a647155031ece = async ()=>{
    const client = $a632bf13a3aa851a$var$getClient();
    try {
        const raw = await client.settings();
        const external = raw.external ?? {};
        return {
            autoconfirm: raw.autoconfirm,
            disableSignup: raw.disable_signup,
            providers: {
                google: external.google ?? false,
                github: external.github ?? false,
                gitlab: external.gitlab ?? false,
                bitbucket: external.bitbucket ?? false,
                facebook: external.facebook ?? false,
                email: external.email ?? false
            }
        };
    } catch (err) {
        throw new $a632bf13a3aa851a$export$145273558d58e0ac(err instanceof Error ? err.message : "Failed to fetch identity settings", 502, {
            cause: err
        });
    }
};
// src/csrf.ts
var $a632bf13a3aa851a$export$821b7df6e4944f14 = (request, options)=>{
    const origin = request.headers.get("origin");
    if (!origin) throw new $a632bf13a3aa851a$export$145273558d58e0ac("Cross-origin request refused: missing Origin header.", 403);
    const allowed = options?.allowedOrigins ?? [
        new URL(request.url).origin
    ];
    if (!allowed.includes(origin)) throw new $a632bf13a3aa851a$export$145273558d58e0ac(`Cross-origin request refused: Origin ${origin} did not match an allowed origin.`, 403);
};
// src/account.ts
var $a632bf13a3aa851a$var$resolveCurrentUser = async ()=>{
    const client = $a632bf13a3aa851a$var$getClient();
    let currentUser = client.currentUser();
    if (!currentUser && $a632bf13a3aa851a$var$isBrowser()) {
        try {
            await $a632bf13a3aa851a$export$5d5568583ad98cbc();
        } catch  {}
        currentUser = client.currentUser();
    }
    if (!currentUser) throw new $a632bf13a3aa851a$export$145273558d58e0ac("No user is currently logged in");
    return currentUser;
};
var $a632bf13a3aa851a$export$358168b22ad3698c = async (email)=>{
    const client = $a632bf13a3aa851a$var$getClient();
    try {
        await client.requestPasswordRecovery(email);
    } catch (error) {
        throw $a632bf13a3aa851a$export$145273558d58e0ac.from(error);
    }
};
var $a632bf13a3aa851a$export$1743464e5cd3b116 = async (token, newPassword)=>{
    const client = $a632bf13a3aa851a$var$getClient();
    try {
        const gotrueUser = await client.recover(token, $a632bf13a3aa851a$var$persistSession);
        const updatedUser = await gotrueUser.update({
            password: newPassword
        });
        const user = $a632bf13a3aa851a$var$toUser(updatedUser);
        $a632bf13a3aa851a$var$startTokenRefresh();
        $a632bf13a3aa851a$var$emitAuthEvent($a632bf13a3aa851a$export$8e89f65f64ee884c.LOGIN, user);
        return user;
    } catch (error) {
        throw $a632bf13a3aa851a$export$145273558d58e0ac.from(error);
    }
};
var $a632bf13a3aa851a$export$d42a822b5f5ae147 = async (token)=>{
    const client = $a632bf13a3aa851a$var$getClient();
    try {
        const gotrueUser = await client.confirm(token, $a632bf13a3aa851a$var$persistSession);
        const user = $a632bf13a3aa851a$var$toUser(gotrueUser);
        $a632bf13a3aa851a$var$startTokenRefresh();
        $a632bf13a3aa851a$var$emitAuthEvent($a632bf13a3aa851a$export$8e89f65f64ee884c.LOGIN, user);
        return user;
    } catch (error) {
        throw $a632bf13a3aa851a$export$145273558d58e0ac.from(error);
    }
};
var $a632bf13a3aa851a$export$f17229473791149b = async (token, password)=>{
    const client = $a632bf13a3aa851a$var$getClient();
    try {
        const gotrueUser = await client.acceptInvite(token, password, $a632bf13a3aa851a$var$persistSession);
        const user = $a632bf13a3aa851a$var$toUser(gotrueUser);
        $a632bf13a3aa851a$var$startTokenRefresh();
        $a632bf13a3aa851a$var$emitAuthEvent($a632bf13a3aa851a$export$8e89f65f64ee884c.LOGIN, user);
        return user;
    } catch (error) {
        throw $a632bf13a3aa851a$export$145273558d58e0ac.from(error);
    }
};
var $a632bf13a3aa851a$export$b6982eb44839dea2 = async (token)=>{
    if (!$a632bf13a3aa851a$var$isBrowser()) throw new $a632bf13a3aa851a$export$145273558d58e0ac("verifyEmailChange() is only available in the browser");
    const currentUser = await $a632bf13a3aa851a$var$resolveCurrentUser();
    try {
        const jwt = await currentUser.jwt();
        const identityUrl = `${window.location.origin}${$a632bf13a3aa851a$var$IDENTITY_PATH}`;
        const res = await fetch(`${identityUrl}/user`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${jwt}`
            },
            body: JSON.stringify({
                email_change_token: token
            })
        });
        if (!res.ok) {
            const errorBody = await res.json().catch(()=>({}));
            throw new $a632bf13a3aa851a$export$145273558d58e0ac(errorBody.msg ?? `Email change verification failed (${String(res.status)})`, res.status);
        }
        const userData = await res.json();
        const user = $a632bf13a3aa851a$var$toUser(userData);
        $a632bf13a3aa851a$var$emitAuthEvent($a632bf13a3aa851a$export$8e89f65f64ee884c.USER_UPDATED, user);
        return user;
    } catch (error) {
        if (error instanceof $a632bf13a3aa851a$export$145273558d58e0ac) throw error;
        throw $a632bf13a3aa851a$export$145273558d58e0ac.from(error);
    }
};
var $a632bf13a3aa851a$export$e3ac7a5d19605772 = async (updates)=>{
    const currentUser = await $a632bf13a3aa851a$var$resolveCurrentUser();
    try {
        const updatedUser = await currentUser.update(updates);
        const user = $a632bf13a3aa851a$var$toUser(updatedUser);
        $a632bf13a3aa851a$var$emitAuthEvent($a632bf13a3aa851a$export$8e89f65f64ee884c.USER_UPDATED, user);
        return user;
    } catch (error) {
        throw $a632bf13a3aa851a$export$145273558d58e0ac.from(error);
    }
};
// src/admin.ts
var $a632bf13a3aa851a$var$SERVER_ONLY_MESSAGE = "Admin operations are server-only. Call admin methods from a Netlify Function or Edge Function, not from browser code.";
var $a632bf13a3aa851a$var$sanitizeUserId = (userId)=>{
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    if (!uuidRegex.test(userId)) throw new $a632bf13a3aa851a$export$145273558d58e0ac("User ID is not a valid UUID");
    return encodeURIComponent(userId);
};
var $a632bf13a3aa851a$var$assertServer = ()=>{
    if ($a632bf13a3aa851a$var$isBrowser()) throw new $a632bf13a3aa851a$export$145273558d58e0ac($a632bf13a3aa851a$var$SERVER_ONLY_MESSAGE);
};
var $a632bf13a3aa851a$var$getAdminAuth = ()=>{
    const ctx = $a632bf13a3aa851a$var$getIdentityContext();
    if (!ctx?.url) throw new $a632bf13a3aa851a$export$145273558d58e0ac("Could not determine the Identity endpoint URL on the server");
    if (!ctx.token) throw new $a632bf13a3aa851a$export$145273558d58e0ac("Admin operations require an operator token (only available in Netlify Functions)");
    return {
        url: ctx.url,
        token: ctx.token
    };
};
var $a632bf13a3aa851a$var$adminFetch = async (path, options = {})=>{
    const { url: url, token: token } = $a632bf13a3aa851a$var$getAdminAuth();
    let res;
    try {
        res = await $a632bf13a3aa851a$var$fetchWithTimeout(`${url}${path}`, {
            ...options,
            headers: {
                ...options.headers,
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
    } catch (error) {
        throw new $a632bf13a3aa851a$export$145273558d58e0ac(error.message, void 0, {
            cause: error
        });
    }
    if (!res.ok) {
        const errorBody = await res.json().catch(()=>({}));
        throw new $a632bf13a3aa851a$export$145273558d58e0ac(errorBody.msg ?? `Admin request failed (${String(res.status)})`, res.status);
    }
    return res;
};
var $a632bf13a3aa851a$var$listUsers = async (options)=>{
    $a632bf13a3aa851a$var$assertServer();
    const params = new URLSearchParams();
    if (options?.page != null) params.set("page", String(options.page));
    if (options?.perPage != null) params.set("per_page", String(options.perPage));
    const query = params.toString();
    const path = `/admin/users${query ? `?${query}` : ""}`;
    const res = await $a632bf13a3aa851a$var$adminFetch(path);
    const body = await res.json();
    return body.users.map($a632bf13a3aa851a$var$toUser);
};
var $a632bf13a3aa851a$var$getUser2 = async (userId)=>{
    $a632bf13a3aa851a$var$assertServer();
    const sanitizedUserId = $a632bf13a3aa851a$var$sanitizeUserId(userId);
    const res = await $a632bf13a3aa851a$var$adminFetch(`/admin/users/${sanitizedUserId}`);
    const userData = await res.json();
    return $a632bf13a3aa851a$var$toUser(userData);
};
var $a632bf13a3aa851a$var$createUser = async (params)=>{
    $a632bf13a3aa851a$var$assertServer();
    const body = {
        email: params.email,
        password: params.password,
        confirm: true
    };
    if (params.data) {
        const allowedKeys = [
            "role",
            "app_metadata",
            "user_metadata"
        ];
        for (const key of allowedKeys)if (key in params.data) body[key] = params.data[key];
    }
    const res = await $a632bf13a3aa851a$var$adminFetch("/admin/users", {
        method: "POST",
        body: JSON.stringify(body)
    });
    const userData = await res.json();
    return $a632bf13a3aa851a$var$toUser(userData);
};
var $a632bf13a3aa851a$var$updateUser2 = async (userId, attributes)=>{
    $a632bf13a3aa851a$var$assertServer();
    const sanitizedUserId = $a632bf13a3aa851a$var$sanitizeUserId(userId);
    const body = {};
    const allowedKeys = [
        "email",
        "password",
        "role",
        "confirm",
        "app_metadata",
        "user_metadata"
    ];
    for (const key of allowedKeys)if (key in attributes) body[key] = attributes[key];
    const res = await $a632bf13a3aa851a$var$adminFetch(`/admin/users/${sanitizedUserId}`, {
        method: "PUT",
        body: JSON.stringify(body)
    });
    const userData = await res.json();
    return $a632bf13a3aa851a$var$toUser(userData);
};
var $a632bf13a3aa851a$var$deleteUser = async (userId)=>{
    $a632bf13a3aa851a$var$assertServer();
    const sanitizedUserId = $a632bf13a3aa851a$var$sanitizeUserId(userId);
    await $a632bf13a3aa851a$var$adminFetch(`/admin/users/${sanitizedUserId}`, {
        method: "DELETE"
    });
};
var $a632bf13a3aa851a$export$7d0f136b730edfdf = {
    listUsers: $a632bf13a3aa851a$var$listUsers,
    getUser: $a632bf13a3aa851a$var$getUser2,
    createUser: $a632bf13a3aa851a$var$createUser,
    updateUser: $a632bf13a3aa851a$var$updateUser2,
    deleteUser: $a632bf13a3aa851a$var$deleteUser
};


const $120842f018687c33$var$app = document.getElementById("app");
const $120842f018687c33$var$params = new URLSearchParams(location.search);
// Only a path on this site may be returned to: never another origin, never a
// scheme-relative "//host" or a backslash some browsers read as one.
const $120842f018687c33$var$safeNext = (raw)=>typeof raw === "string" && raw.length <= 512 && /^\/(?![/\\])[^\s\\]*$/.test(raw) ? raw : "/";
const $120842f018687c33$var$next = $120842f018687c33$var$safeNext($120842f018687c33$var$params.get("next"));
const $120842f018687c33$var$PW_MIN = 8;
const $120842f018687c33$var$esc = (s)=>String(s ?? "").replace(/[&<>"']/g, (c)=>({
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;"
        })[c]);
// @netlify/identity writes its cookies for the browser session only, so every
// browser restart would mean signing in again. The gate keeps them for 30 days
// when it renews them; this does the same after a sign-in here.
const $120842f018687c33$var$MAX_AGE = 2592000;
function $120842f018687c33$var$persist() {
    for (const name of [
        "nf_jwt",
        "nf_refresh"
    ]){
        const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
        if (m) document.cookie = `${name}=${m[1]}; path=/; secure; samesite=lax; max-age=${$120842f018687c33$var$MAX_AGE}`;
    }
}
function $120842f018687c33$var$proceed() {
    $120842f018687c33$var$persist();
    location.replace($120842f018687c33$var$next);
}
// What GoTrue says is written for developers; these are the ones people meet.
function $120842f018687c33$var$friendly(err, fallback) {
    const msg = String(err?.message || "");
    if (/invalid|no user found|password/i.test(msg) && /login|grant|password|user/i.test(msg)) return "That email and password don't match an account.";
    if (/not confirmed/i.test(msg)) return "Confirm your email address first: open the link in the email you were sent.";
    if (/rate|too many/i.test(msg)) return "Too many attempts. Wait a minute and try again.";
    if (/network|fetch|timeout|failed to fetch/i.test(msg)) return "Couldn't reach the sign-in service. Check your connection and try again.";
    return fallback || msg || "Something went wrong. Please try again.";
}
let $120842f018687c33$var$signupOpen = false;
function $120842f018687c33$var$view({ sub: sub, note: note = "", noteKind: noteKind = "ok", fields: fields = "", button: button = "", after: after = "" }) {
    $120842f018687c33$var$app.innerHTML = `<div class="brand">\u{25C6} NorthStar protected zone</div>
    <p class="sub">${sub}</p>
    ${note ? `<div class="${noteKind}" role="${noteKind === "err" ? "alert" : "status"}">${$120842f018687c33$var$esc(note)}</div>` : ""}
    ${fields || button ? `<form id="f" novalidate>${fields}${button ? `<button class="go" type="submit">${button}</button>` : ""}</form>` : ""}
    ${after}`;
    const first = $120842f018687c33$var$app.querySelector("input:not([type=hidden])");
    if (first) first.focus();
    return $120842f018687c33$var$app.querySelector("#f");
}
// Runs a form's action with the button disabled; an error re-renders the view
// with the message and whatever the visitor had typed (never a password).
function $120842f018687c33$var$onSubmit(form, action) {
    form.addEventListener("submit", async (e)=>{
        e.preventDefault();
        const btn = form.querySelector("button[type=submit]");
        const data = Object.fromEntries(new FormData(form));
        btn.disabled = true;
        try {
            await action(data);
        } finally{
            if (btn.isConnected) btn.disabled = false;
        }
    });
}
function $120842f018687c33$var$passwordProblem(password, confirm) {
    if (password.length < $120842f018687c33$var$PW_MIN) return `Choose a password of at least ${$120842f018687c33$var$PW_MIN} characters.`;
    if (password !== confirm) return "The two passwords do not match.";
    return "";
}
const $120842f018687c33$var$emailField = (value = "", autocomplete = "username")=>`<input class="pw" type="email" name="email" placeholder="Email" value="${$120842f018687c33$var$esc(value)}" autocomplete="${autocomplete}" required>`;
const $120842f018687c33$var$newPasswordFields = `<input class="pw" type="password" name="password" placeholder="New password" autocomplete="new-password" minlength="${$120842f018687c33$var$PW_MIN}" required>
      <input class="pw" type="password" name="confirm" placeholder="Repeat password" autocomplete="new-password" minlength="${$120842f018687c33$var$PW_MIN}" required>
      <p class="hint">At least ${$120842f018687c33$var$PW_MIN} characters.</p>`;
function $120842f018687c33$var$link(id, text) {
    return `<button type="button" id="${id}">${text}</button>`;
}
function $120842f018687c33$var$wire(id, fn) {
    const el = $120842f018687c33$var$app.querySelector(`#${id}`);
    if (el) el.addEventListener("click", fn);
}
// ---- the views -------------------------------------------------------------------
function $120842f018687c33$var$showSignIn({ note: note = "", noteKind: noteKind = "ok", email: email = "" } = {}) {
    const form = $120842f018687c33$var$view({
        sub: "Sign in with the email address and password of your account.",
        note: note,
        noteKind: noteKind,
        fields: `${$120842f018687c33$var$emailField(email)}
      <input class="pw" type="password" name="password" placeholder="Password" autocomplete="current-password" required>`,
        button: "Sign in",
        after: `<p class="links">${$120842f018687c33$var$link("forgot", "Forgot your password?")}${$120842f018687c33$var$signupOpen ? `<br>No account? ${$120842f018687c33$var$link("signup", "Create one")}` : "<br>No account? Ask the site admin for an invitation."}</p>`
    });
    $120842f018687c33$var$wire("forgot", ()=>$120842f018687c33$var$showForgot());
    $120842f018687c33$var$wire("signup", ()=>$120842f018687c33$var$showSignUp());
    $120842f018687c33$var$onSubmit(form, async ({ email: e, password: password })=>{
        if (!e || !password) return $120842f018687c33$var$showSignIn({
            note: "Enter your email address and password.",
            noteKind: "err",
            email: e
        });
        try {
            await (0, $a632bf13a3aa851a$export$596d806903d1f59e)(e.trim(), password);
            $120842f018687c33$var$proceed();
        } catch (err) {
            $120842f018687c33$var$showSignIn({
                note: $120842f018687c33$var$friendly(err),
                noteKind: "err",
                email: e
            });
        }
    });
}
function $120842f018687c33$var$showForgot({ note: note = "", noteKind: noteKind = "ok", email: email = "" } = {}) {
    const form = $120842f018687c33$var$view({
        sub: "Enter the email address of your account and we'll send you a link to choose a new password.",
        note: note,
        noteKind: noteKind,
        fields: $120842f018687c33$var$emailField(email, "email"),
        button: "Send the link",
        after: `<p class="links">${$120842f018687c33$var$link("back", "Back to sign in")}</p>`
    });
    $120842f018687c33$var$wire("back", ()=>$120842f018687c33$var$showSignIn({
            email: email
        }));
    $120842f018687c33$var$onSubmit(form, async ({ email: e })=>{
        if (!e) return $120842f018687c33$var$showForgot({
            note: "Enter your email address.",
            noteKind: "err"
        });
        try {
            await (0, $a632bf13a3aa851a$export$358168b22ad3698c)(e.trim());
            // Said whether or not the address has an account, so the form does not
            // tell a stranger which addresses do.
            $120842f018687c33$var$showSignIn({
                note: "If that address has an account, an email with a link to choose a new password is on its way.",
                email: e
            });
        } catch (err) {
            $120842f018687c33$var$showForgot({
                note: $120842f018687c33$var$friendly(err, "Couldn't send the email. Please try again."),
                noteKind: "err",
                email: e
            });
        }
    });
}
function $120842f018687c33$var$showInvite(token, { note: note = "", noteKind: noteKind = "err" } = {}) {
    const form = $120842f018687c33$var$view({
        sub: "You've been invited. Choose the password you will sign in with.",
        note: note,
        noteKind: noteKind,
        fields: $120842f018687c33$var$newPasswordFields,
        button: "Create my account"
    });
    $120842f018687c33$var$onSubmit(form, async ({ password: password, confirm: confirm })=>{
        const bad = $120842f018687c33$var$passwordProblem(password, confirm);
        if (bad) return $120842f018687c33$var$showInvite(token, {
            note: bad
        });
        let user;
        try {
            user = await (0, $a632bf13a3aa851a$export$f17229473791149b)(token, password);
        } catch (err) {
            return $120842f018687c33$var$showSignIn({
                note: /not found|invalid|expired/i.test(String(err?.message)) ? "This invitation link has expired or was already used. If you set a password with it, sign in below; otherwise ask the site admin for a new invitation." : $120842f018687c33$var$friendly(err),
                noteKind: "err"
            });
        }
        // acceptInvite() starts a session in the browser but writes no cookies, and
        // the cookies are what the gate checks. Signing in with the password just
        // chosen is the documented way to write them.
        try {
            await (0, $a632bf13a3aa851a$export$596d806903d1f59e)(user.email, password);
            $120842f018687c33$var$proceed();
        } catch  {
            $120842f018687c33$var$showSignIn({
                note: "Your account is ready. Sign in with your new password.",
                email: user.email
            });
        }
    });
}
function $120842f018687c33$var$showNewPassword({ note: note = "", noteKind: noteKind = "err" } = {}) {
    const form = $120842f018687c33$var$view({
        sub: "Choose a new password for your account.",
        note: note,
        noteKind: noteKind,
        fields: $120842f018687c33$var$newPasswordFields,
        button: "Save the new password"
    });
    $120842f018687c33$var$onSubmit(form, async ({ password: password, confirm: confirm })=>{
        const bad = $120842f018687c33$var$passwordProblem(password, confirm);
        if (bad) return $120842f018687c33$var$showNewPassword({
            note: bad
        });
        try {
            await (0, $a632bf13a3aa851a$export$e3ac7a5d19605772)({
                password: password
            });
            $120842f018687c33$var$proceed();
        } catch (err) {
            $120842f018687c33$var$showNewPassword({
                note: $120842f018687c33$var$friendly(err, "Couldn't save the password. Please try again.")
            });
        }
    });
}
function $120842f018687c33$var$showSignUp({ note: note = "", noteKind: noteKind = "err", email: email = "" } = {}) {
    const form = $120842f018687c33$var$view({
        sub: "Create an account with your email address. We'll send you a link to confirm it.",
        note: note,
        noteKind: noteKind,
        fields: `${$120842f018687c33$var$emailField(email, "email")}${$120842f018687c33$var$newPasswordFields}`,
        button: "Create account",
        after: `<p class="links">Already have an account? ${$120842f018687c33$var$link("back", "Sign in")}</p>`
    });
    $120842f018687c33$var$wire("back", ()=>$120842f018687c33$var$showSignIn({
            email: email
        }));
    $120842f018687c33$var$onSubmit(form, async ({ email: e, password: password, confirm: confirm })=>{
        if (!e) return $120842f018687c33$var$showSignUp({
            note: "Enter your email address."
        });
        const bad = $120842f018687c33$var$passwordProblem(password, confirm);
        if (bad) return $120842f018687c33$var$showSignUp({
            note: bad,
            email: e
        });
        try {
            const user = await (0, $a632bf13a3aa851a$export$7200a869094fec36)(e.trim(), password);
            if (user.confirmedAt) return $120842f018687c33$var$proceed();
            $120842f018687c33$var$showSignIn({
                note: "Almost there: open the link in the email we just sent to confirm your address, then sign in.",
                email: e
            });
        } catch (err) {
            $120842f018687c33$var$showSignUp({
                note: $120842f018687c33$var$friendly(err),
                email: e
            });
        }
    });
}
function $120842f018687c33$var$showSignedIn(user, { note: note = "" } = {}) {
    $120842f018687c33$var$view({
        sub: `Signed in as <span class="who">${$120842f018687c33$var$esc(user.email)}</span>.`,
        note: note,
        after: `<button class="go" type="button" id="continue">Continue</button>
      <button class="go alt" type="button" id="signout">Sign out</button>`
    });
    $120842f018687c33$var$wire("continue", $120842f018687c33$var$proceed);
    $120842f018687c33$var$wire("signout", async ()=>{
        try {
            await (0, $a632bf13a3aa851a$export$a0973bcfe11b05c9)();
        } catch  {}
        $120842f018687c33$var$showSignIn({
            note: "You are signed out."
        });
    });
}
// ---- start -------------------------------------------------------------------------
async function $120842f018687c33$var$start() {
    try {
        $120842f018687c33$var$signupOpen = !(await (0, $a632bf13a3aa851a$export$4a647155031ece)()).disableSignup;
    } catch  {
        $120842f018687c33$var$signupOpen = false;
    }
    let result = null;
    try {
        result = await (0, $a632bf13a3aa851a$export$213a2dc2015f93c1)();
    } catch (err) {
        history.replaceState(null, "", location.pathname + location.search);
        return $120842f018687c33$var$showSignIn({
            note: "That link has expired or was already used. Sign in, or ask for a new one.",
            noteKind: "err"
        });
    }
    if (result?.type === "invite" && result.token) return $120842f018687c33$var$showInvite(result.token);
    if (result?.type === "recovery") return $120842f018687c33$var$showNewPassword({
        note: "",
        noteKind: "ok"
    });
    if (result?.type === "confirmation" || result?.type === "oauth") return $120842f018687c33$var$proceed();
    // Arrived from ?signout=1: the gate has cleared the cookies; this ends the
    // browser's own copy of the session as well.
    if ($120842f018687c33$var$params.has("signedout")) {
        try {
            await (0, $a632bf13a3aa851a$export$a0973bcfe11b05c9)();
        } catch  {}
        return $120842f018687c33$var$showSignIn({
            note: "You are signed out."
        });
    }
    const user = await (0, $a632bf13a3aa851a$export$7cbf767827cd68ba)();
    if (user) return $120842f018687c33$var$showSignedIn(user, {
        note: result?.type === "email_change" ? "Your email address has been changed." : ""
    });
    $120842f018687c33$var$showSignIn();
}
$120842f018687c33$var$start();


//# sourceMappingURL=login.5c1bc8fd.js.map
